import type { RealtimeChannel, RealtimeHandler } from './realtime-client';

/**
 * A swappable realtime transport seam. Features subscribe to channels through this
 * indirection rather than holding a socket directly, so boot can install either the
 * real socket.io client (go-live) or the in-memory mock bus (VITE_MOCK_API) without
 * features knowing which. Keeps `lib` free of any dependency on the `test` mock layer
 * (boundaries) — boot does the wiring.
 */
export type RealtimeTransport = {
  subscribe: <T = unknown>(channel: RealtimeChannel, handler: RealtimeHandler<T>) => () => void;
};

let current: RealtimeTransport | null = null;

export function setRealtimeTransport(transport: RealtimeTransport | null): void {
  current = transport;
}

/** Subscribe to a channel via the installed transport. No-op (returns a no-op
 *  unsubscribe) when no transport is installed yet, so callers never crash pre-boot. */
export function realtimeSubscribe<T = unknown>(
  channel: RealtimeChannel,
  handler: RealtimeHandler<T>,
): () => void {
  if (!current) return () => {};
  return current.subscribe(channel, handler);
}
